/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('DOMContentLoaded', function() {
  let lastScrollTop = 0;
  const navBar = document.querySelector('.nav-bar');
  const scrollBuffer = 10; // Ignore tiny scrolls that cause flickering

  window.addEventListener("scroll", function() {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // Calculate the difference from the last scroll
    if (Math.abs(lastScrollTop - currentScroll) <= scrollBuffer) return;

    // Only start effect after scrolling past the main header (roughly 200px)
    if (currentScroll > 200) {
      if (currentScroll > lastScrollTop) {
        // Scrolling Down - Force Hide
        navBar.classList.remove('nav-sticky-show');
        navBar.classList.add('nav-sticky-hide');
      } else {
        // Scrolling Up - Show
        navBar.classList.remove('nav-sticky-hide');
        navBar.classList.add('nav-sticky-show');
      }
    } else {
      // Return to top - remove all custom sticky classes
      navBar.classList.remove('nav-sticky-show', 'nav-sticky-hide');
    }
    
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }, { passive: true });
});